//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
import * as tslib_1 from "tslib";
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
export var API_BASE_URL_ADMINISTRATOR = new InjectionToken('API_BASE_URL_ADMINISTRATOR');
var AdministratorClient = /** @class */ (function () {
    function AdministratorClient(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * Post account
     * @param body (optional) The account to create
     * @return The created or updated account
     */
    AdministratorClient.prototype.createAccount = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processCreateAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result201 = null;
                var resultData201 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result201 = AccountDto.fromJS(resultData201);
                return _observableOf(result201);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get accounts
     * @return Returns a list of accounts
     */
    AdministratorClient.prototype.getAllAccounts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/accounts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllAccounts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllAccounts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetAllAccounts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(AccountDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Put account
     * @param body (optional) The account to update
     * @return The updated account
     */
    AdministratorClient.prototype.updateAccount = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processUpdateAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result204 = null;
                var resultData204 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result204 = AccountDto.fromJS(resultData204);
                return _observableOf(result204);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get one account
     * @return Returns an account
     */
    AdministratorClient.prototype.getAccount = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get clients by account id
     * @param id The account id
     * @param atsEnabled (optional) Indicate if ats is enabled for the clients
     * @return Returns a list of clients of the specified account
     */
    AdministratorClient.prototype.getClientsForAccount = function (id, atsEnabled) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}/clients?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (atsEnabled === null)
            throw new Error("The parameter 'atsEnabled' cannot be null.");
        else if (atsEnabled !== undefined)
            url_ += "atsEnabled=" + encodeURIComponent("" + atsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientsForAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientsForAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetClientsForAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(ClientDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scans for account
     * @param id The id of the account you want to get the job scans for
     * @param externalRef (optional) The unique reference of the job scan at the account side
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning job scans should include expectations or not
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of job scans for the specified account
     */
    AdministratorClient.prototype.getJobScansForAccount = function (id, externalRef, shouldHaveExpectations, includeExpectations, teamRoleIds, workValueIds, offset, count, sort, search, domainIds) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}/jobscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScansForAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScansForAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetJobScansForAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(JobScanDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scans for account and client type
     * @param id The id of the account you want to get the job scans for
     * @param clientTypeId The id of the client type you want to get the job scans for
     * @param externalRef (optional) The unique reference of the job scan at the account side
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning job scans should include expectations or not
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on contact name, contact email, title and employer. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns a list of job scans for the specified account
     */
    AdministratorClient.prototype.getJobScansForAccountAndClientType = function (id, clientTypeId, externalRef, shouldHaveExpectations, includeExpectations, teamRoleIds, workValueIds, offset, count, sort, search, domainIds) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}/clienttype/{clientTypeId}/jobscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clientTypeId === undefined || clientTypeId === null)
            throw new Error("The parameter 'clientTypeId' must be defined.");
        url_ = url_.replace("{clientTypeId}", encodeURIComponent("" + clientTypeId));
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScansForAccountAndClientType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScansForAccountAndClientType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetJobScansForAccountAndClientType = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(JobScanDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get the total number of job scans for the account
     * @param id The account id
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not.
                This parameter is ignored if there are team role ids or work value ids.
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns the total number of job scans for the account
     */
    AdministratorClient.prototype.getTotalNumberOfJobScansForAccount = function (id, shouldHaveExpectations, teamRoleIds, workValueIds, search, domainIds) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}/jobscans/totalcount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTotalNumberOfJobScansForAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTotalNumberOfJobScansForAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetTotalNumberOfJobScansForAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get the total number of job scans for the account
     * @param id The account id
     * @param clientTypeId The client type id
     * @param shouldHaveExpectations (optional) Whether the job scan should have expectations or not.
                This parameter is ignored if there are team role ids or work value ids.
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns the total number of job scans for the account
     */
    AdministratorClient.prototype.getTotalNumberOfJobScansForAccountAndClientType = function (id, clientTypeId, shouldHaveExpectations, teamRoleIds, workValueIds, search, domainIds) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}/clienttype/{clientTypeId}/jobscans/totalcount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clientTypeId === undefined || clientTypeId === null)
            throw new Error("The parameter 'clientTypeId' must be defined.");
        url_ = url_.replace("{clientTypeId}", encodeURIComponent("" + clientTypeId));
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTotalNumberOfJobScansForAccountAndClientType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTotalNumberOfJobScansForAccountAndClientType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetTotalNumberOfJobScansForAccountAndClientType = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scans for account
     * @param id The account id
     * @param externalRef (optional) The unique reference of the talentscan at the account side
     * @param shouldHaveExpectations (optional) Whether the talent scan should have expectations or not
     * @param includeExpectations (optional) Whether the returning talent scans should include expectations or not
     * @param teamRoleIds (optional) A comma-separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma-separated list of work value expectation ids to filter on
     * @param offset (optional) The offset used for pagination
     * @param count (optional) The number of records to return. Standard set to 100
     * @param sort (optional) The fields to order by, comma separated
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma-separated list of domain ids
     * @param atsClientId (optional) The Ats Client id
     * @return Returns a list of talent scans for the specified account
     */
    AdministratorClient.prototype.getTalentScansForAccount = function (id, externalRef, shouldHaveExpectations, includeExpectations, teamRoleIds, workValueIds, offset, count, sort, search, domainIds, atsClientId) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}/talentscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (externalRef === null)
            throw new Error("The parameter 'externalRef' cannot be null.");
        else if (externalRef !== undefined)
            url_ += "externalRef=" + encodeURIComponent("" + externalRef) + "&";
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (includeExpectations === null)
            throw new Error("The parameter 'includeExpectations' cannot be null.");
        else if (includeExpectations !== undefined)
            url_ += "includeExpectations=" + encodeURIComponent("" + includeExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        if (atsClientId === null)
            throw new Error("The parameter 'atsClientId' cannot be null.");
        else if (atsClientId !== undefined)
            url_ += "atsClientId=" + encodeURIComponent("" + atsClientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScansForAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScansForAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetTalentScansForAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(TalentScanDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get the total number of talent scans for the account
     * @param id The account id
     * @param shouldHaveExpectations (optional) Whether the talent scan should have expectations or not. This parameter is ignored if there
    are team role ids or work value ids.
     * @param teamRoleIds (optional) A comma separated list of team role expectation ids to filter on
     * @param workValueIds (optional) A comma separated list of work value expectation ids to filter on
     * @param search (optional) The search string that is used to search on name and email. Partial matches are allowed.
     * @param domainIds (optional) A comma separated list of domain ids
     * @return Returns the total number of talent scans for the account
     */
    AdministratorClient.prototype.getTotalNumberOfTalentScansForAccount = function (id, shouldHaveExpectations, teamRoleIds, workValueIds, search, domainIds) {
        var _this = this;
        var url_ = this.baseUrl + "/accounts/{id}/talentscans/totalcount?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (shouldHaveExpectations === null)
            throw new Error("The parameter 'shouldHaveExpectations' cannot be null.");
        else if (shouldHaveExpectations !== undefined)
            url_ += "shouldHaveExpectations=" + encodeURIComponent("" + shouldHaveExpectations) + "&";
        if (teamRoleIds === null)
            throw new Error("The parameter 'teamRoleIds' cannot be null.");
        else if (teamRoleIds !== undefined)
            url_ += "teamRoleIds=" + encodeURIComponent("" + teamRoleIds) + "&";
        if (workValueIds === null)
            throw new Error("The parameter 'workValueIds' cannot be null.");
        else if (workValueIds !== undefined)
            url_ += "workValueIds=" + encodeURIComponent("" + workValueIds) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (domainIds === null)
            throw new Error("The parameter 'domainIds' cannot be null.");
        else if (domainIds !== undefined)
            url_ += "domainIds=" + encodeURIComponent("" + domainIds) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTotalNumberOfTalentScansForAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTotalNumberOfTalentScansForAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetTotalNumberOfTalentScansForAccount = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Send email
     * @param body (optional)
     * @return Success
     */
    AdministratorClient.prototype.sendEmail = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/actions/email";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processSendEmail = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = EmailActionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("Accepted http response code", status, _responseText, _headers);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get ATS Client by name
     * @param name The unique name of the ATS Client
     * @return Success
     */
    AdministratorClient.prototype.getAtsClientByName = function (name) {
        var _this = this;
        var url_ = this.baseUrl + "/atsclients/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAtsClientByName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAtsClientByName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetAtsClientByName = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AtsClientDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Create AtsClient
     * @param body (optional) The Ats client to create
     * @return Returns the created AtsClient
     */
    AdministratorClient.prototype.createAtsClient = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/atsclients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateAtsClient(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateAtsClient(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processCreateAtsClient = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AtsClientDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Update ATS client
     * @param body (optional) The ATS client to update
     * @return The updated ATS client
     */
    AdministratorClient.prototype.updateAtsClient = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/atsclients";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAtsClient(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAtsClient(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processUpdateAtsClient = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result201 = null;
                var resultData201 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result201 = AtsClientDto.fromJS(resultData201);
                return _observableOf(result201);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Create a talent scan for the specified client
     * @param id The unique identifier of the client.
     * @param language (optional) The two-letter iso code for the talent scan's language, eg 'en'
     * @param body (optional) The talent scan to be created
     * @return Success
     */
    AdministratorClient.prototype.createTalentScanForClient = function (id, language, body) {
        var _this = this;
        var url_ = this.baseUrl + "/clients/{id}/talentscans?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTalentScanForClient(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTalentScanForClient(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processCreateTalentScanForClient = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TalentScanDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get Clients
     * @return Returns a list of clients
     */
    AdministratorClient.prototype.getAllClients = function () {
        var _this = this;
        var url_ = this.baseUrl + "/clients";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllClients(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllClients(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetAllClients = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(ClientDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get one client
     * @return Returns a client
     */
    AdministratorClient.prototype.getClientById = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/clients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClientById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClientById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetClientById = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ClientDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get permissions
     * @return Success
     */
    AdministratorClient.prototype.getPermissions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/permissions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetPermissions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(PermissionDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get template
     * @param body (optional) Contains the template name, language and placeholders
     * @return Success
     */
    AdministratorClient.prototype.getTemplate = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/templates";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTemplate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTemplate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetTemplate = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get current authenticated user
     * @return Success
     */
    AdministratorClient.prototype.getMe = function () {
        var _this = this;
        var url_ = this.baseUrl + "/users/me";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMe(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMe(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetMe = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get accounts for the current authenticated user
     * @return Success
     */
    AdministratorClient.prototype.getMyActiveAccounts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/users/me/accounts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyActiveAccounts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyActiveAccounts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processGetMyActiveAccounts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(AccountDto.fromJS(item));
                    }
                }
                else {
                    result200 = null;
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Create or update a user
     * @param body (optional) The user to be created or updated
     * @return Success
     */
    AdministratorClient.prototype.updateUser = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdministratorClient.prototype.processUpdateUser = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return AdministratorClient;
}());
export { AdministratorClient };
var AccountDto = /** @class */ (function () {
    function AccountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.logoUrl = _data["logoUrl"];
        }
    };
    AccountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountDto();
        result.init(data);
        return result;
    };
    AccountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["logoUrl"] = this.logoUrl;
        return data;
    };
    return AccountDto;
}());
export { AccountDto };
var ApiError = /** @class */ (function () {
    function ApiError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiError.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    };
    ApiError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiError();
        result.init(data);
        return result;
    };
    ApiError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    };
    return ApiError;
}());
export { ApiError };
var ApiErrorResponse = /** @class */ (function () {
    function ApiErrorResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiErrorResponse.prototype.init = function (_data) {
        if (_data) {
            this.apiError = _data["apiError"] ? ApiError.fromJS(_data["apiError"]) : undefined;
            this.correlationId = _data["correlationId"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (var _i = 0, _a = _data["validationErrors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationErrors.push(ValidationError.fromJS(item));
                }
            }
            this.detail = _data["detail"];
        }
    };
    ApiErrorResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiErrorResponse();
        result.init(data);
        return result;
    };
    ApiErrorResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["apiError"] = this.apiError ? this.apiError.toJSON() : undefined;
        data["correlationId"] = this.correlationId;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (var _i = 0, _a = this.validationErrors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationErrors"].push(item.toJSON());
            }
        }
        data["detail"] = this.detail;
        return data;
    };
    return ApiErrorResponse;
}());
export { ApiErrorResponse };
var AtsClientDto = /** @class */ (function () {
    function AtsClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AtsClientDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.atsId = _data["atsId"];
            this.accountId = _data["accountId"];
            this.apiId = _data["apiId"];
            this.apiToken = _data["apiToken"];
            this.id = _data["id"];
            this.active = _data["active"];
        }
    };
    AtsClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AtsClientDto();
        result.init(data);
        return result;
    };
    AtsClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["atsId"] = this.atsId;
        data["accountId"] = this.accountId;
        data["apiId"] = this.apiId;
        data["apiToken"] = this.apiToken;
        data["id"] = this.id;
        data["active"] = this.active;
        return data;
    };
    return AtsClientDto;
}());
export { AtsClientDto };
var ClientDto = /** @class */ (function () {
    function ClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClientDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.accountId = _data["accountId"];
            this.theme = _data["theme"];
            this.talentScanUrl = _data["talentScanUrl"];
            this.displayName = _data["displayName"];
            this.adminReportUrl = _data["adminReportUrl"];
            this.defaultReportUrl = _data["defaultReportUrl"];
            this.ccReportUrl = _data["ccReportUrl"];
        }
    };
    ClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClientDto();
        result.init(data);
        return result;
    };
    ClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["accountId"] = this.accountId;
        data["theme"] = this.theme;
        data["talentScanUrl"] = this.talentScanUrl;
        data["displayName"] = this.displayName;
        data["adminReportUrl"] = this.adminReportUrl;
        data["defaultReportUrl"] = this.defaultReportUrl;
        data["ccReportUrl"] = this.ccReportUrl;
        return data;
    };
    return ClientDto;
}());
export { ClientDto };
var CreateAccountDto = /** @class */ (function () {
    function CreateAccountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateAccountDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.logoUrl = _data["logoUrl"];
        }
    };
    CreateAccountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateAccountDto();
        result.init(data);
        return result;
    };
    CreateAccountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["logoUrl"] = this.logoUrl;
        return data;
    };
    return CreateAccountDto;
}());
export { CreateAccountDto };
var CreateAtsClientDto = /** @class */ (function () {
    function CreateAtsClientDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateAtsClientDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.atsId = _data["atsId"];
            this.accountId = _data["accountId"];
            this.apiId = _data["apiId"];
            this.apiToken = _data["apiToken"];
        }
    };
    CreateAtsClientDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateAtsClientDto();
        result.init(data);
        return result;
    };
    CreateAtsClientDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["atsId"] = this.atsId;
        data["accountId"] = this.accountId;
        data["apiId"] = this.apiId;
        data["apiToken"] = this.apiToken;
        return data;
    };
    return CreateAtsClientDto;
}());
export { CreateAtsClientDto };
var CreateTalentScanDto = /** @class */ (function () {
    function CreateTalentScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTalentScanDto.prototype.init = function (_data) {
        if (_data) {
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _i = 0, _a = _data["clusterIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clusterIds.push(item);
                }
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _b = 0, _c = _data["domainIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.domainIds.push(item);
                }
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _d = 0, _e = _data["schoolIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.schoolIds.push(item);
                }
            }
            this.theme = _data["theme"];
        }
    };
    CreateTalentScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTalentScanDto();
        result.init(data);
        return result;
    };
    CreateTalentScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _i = 0, _a = this.clusterIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clusterIds"].push(item);
            }
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _b = 0, _c = this.domainIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["domainIds"].push(item);
            }
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _d = 0, _e = this.schoolIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["schoolIds"].push(item);
            }
        }
        data["theme"] = this.theme;
        return data;
    };
    return CreateTalentScanDto;
}());
export { CreateTalentScanDto };
var EmailActionDto = /** @class */ (function () {
    function EmailActionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmailActionDto.prototype.init = function (_data) {
        if (_data) {
            this.fromAddress = _data["fromAddress"];
            if (Array.isArray(_data["destinationAddresses"])) {
                this.destinationAddresses = [];
                for (var _i = 0, _a = _data["destinationAddresses"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.destinationAddresses.push(item);
                }
            }
            if (Array.isArray(_data["ccAddresses"])) {
                this.ccAddresses = [];
                for (var _b = 0, _c = _data["ccAddresses"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.ccAddresses.push(item);
                }
            }
            if (Array.isArray(_data["bccAddresses"])) {
                this.bccAddresses = [];
                for (var _d = 0, _e = _data["bccAddresses"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.bccAddresses.push(item);
                }
            }
            this.subject = _data["subject"];
            this.htmlBody = _data["htmlBody"];
            this.templateRequest = _data["templateRequest"] ? TemplateRequestDto.fromJS(_data["templateRequest"]) : undefined;
        }
    };
    EmailActionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmailActionDto();
        result.init(data);
        return result;
    };
    EmailActionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fromAddress"] = this.fromAddress;
        if (Array.isArray(this.destinationAddresses)) {
            data["destinationAddresses"] = [];
            for (var _i = 0, _a = this.destinationAddresses; _i < _a.length; _i++) {
                var item = _a[_i];
                data["destinationAddresses"].push(item);
            }
        }
        if (Array.isArray(this.ccAddresses)) {
            data["ccAddresses"] = [];
            for (var _b = 0, _c = this.ccAddresses; _b < _c.length; _b++) {
                var item = _c[_b];
                data["ccAddresses"].push(item);
            }
        }
        if (Array.isArray(this.bccAddresses)) {
            data["bccAddresses"] = [];
            for (var _d = 0, _e = this.bccAddresses; _d < _e.length; _d++) {
                var item = _e[_d];
                data["bccAddresses"].push(item);
            }
        }
        data["subject"] = this.subject;
        data["htmlBody"] = this.htmlBody;
        data["templateRequest"] = this.templateRequest ? this.templateRequest.toJSON() : undefined;
        return data;
    };
    return EmailActionDto;
}());
export { EmailActionDto };
var ExpectationDto = /** @class */ (function () {
    function ExpectationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExpectationDto.prototype.init = function (_data) {
        if (_data) {
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    };
    ExpectationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExpectationDto();
        result.init(data);
        return result;
    };
    ExpectationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data;
    };
    return ExpectationDto;
}());
export { ExpectationDto };
var JobScanDto = /** @class */ (function () {
    function JobScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    JobScanDto.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.contactEmail = _data["contactEmail"];
            if (Array.isArray(_data["contactCcEmail"])) {
                this.contactCcEmail = [];
                for (var _i = 0, _a = _data["contactCcEmail"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.contactCcEmail.push(item);
                }
            }
            this.contactPhone = _data["contactPhone"];
            this.employer = _data["employer"];
            this.externalRef = _data["externalRef"];
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _b = 0, _c = _data["domainIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.domainIds.push(item);
                }
            }
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _d = 0, _e = _data["schoolIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.schoolIds.push(item);
                }
            }
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _f = 0, _g = _data["clusterIds"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.clusterIds.push(item);
                }
            }
            this.theme = _data["theme"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [];
                for (var _h = 0, _j = _data["expectations"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.expectations.push(ExpectationDto.fromJS(item));
                }
            }
        }
    };
    JobScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new JobScanDto();
        result.init(data);
        return result;
    };
    JobScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["contactEmail"] = this.contactEmail;
        if (Array.isArray(this.contactCcEmail)) {
            data["contactCcEmail"] = [];
            for (var _i = 0, _a = this.contactCcEmail; _i < _a.length; _i++) {
                var item = _a[_i];
                data["contactCcEmail"].push(item);
            }
        }
        data["contactPhone"] = this.contactPhone;
        data["employer"] = this.employer;
        data["externalRef"] = this.externalRef;
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _b = 0, _c = this.domainIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["domainIds"].push(item);
            }
        }
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _d = 0, _e = this.schoolIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["schoolIds"].push(item);
            }
        }
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _f = 0, _g = this.clusterIds; _f < _g.length; _f++) {
                var item = _g[_f];
                data["clusterIds"].push(item);
            }
        }
        data["theme"] = this.theme;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (var _h = 0, _j = this.expectations; _h < _j.length; _h++) {
                var item = _j[_h];
                data["expectations"].push(item.toJSON());
            }
        }
        return data;
    };
    return JobScanDto;
}());
export { JobScanDto };
var PermissionDto = /** @class */ (function () {
    function PermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PermissionDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.action = _data["action"];
            this.resource = _data["resource"];
        }
    };
    PermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PermissionDto();
        result.init(data);
        return result;
    };
    PermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["action"] = this.action;
        data["resource"] = this.resource;
        return data;
    };
    return PermissionDto;
}());
export { PermissionDto };
var TalentScanDto = /** @class */ (function () {
    function TalentScanDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TalentScanDto.prototype.init = function (_data) {
        if (_data) {
            this.atsClientId = _data["atsClientId"];
            if (Array.isArray(_data["clusterIds"])) {
                this.clusterIds = [];
                for (var _i = 0, _a = _data["clusterIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.clusterIds.push(item);
                }
            }
            if (Array.isArray(_data["domainIds"])) {
                this.domainIds = [];
                for (var _b = 0, _c = _data["domainIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.domainIds.push(item);
                }
            }
            this.email = _data["email"];
            this.externalRef = _data["externalRef"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.nationality = _data["nationality"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["schoolIds"])) {
                this.schoolIds = [];
                for (var _d = 0, _e = _data["schoolIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.schoolIds.push(item);
                }
            }
            this.theme = _data["theme"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined;
            if (Array.isArray(_data["expectations"])) {
                this.expectations = [];
                for (var _f = 0, _g = _data["expectations"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.expectations.push(ExpectationDto.fromJS(item));
                }
            }
        }
    };
    TalentScanDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TalentScanDto();
        result.init(data);
        return result;
    };
    TalentScanDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["atsClientId"] = this.atsClientId;
        if (Array.isArray(this.clusterIds)) {
            data["clusterIds"] = [];
            for (var _i = 0, _a = this.clusterIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["clusterIds"].push(item);
            }
        }
        if (Array.isArray(this.domainIds)) {
            data["domainIds"] = [];
            for (var _b = 0, _c = this.domainIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["domainIds"].push(item);
            }
        }
        data["email"] = this.email;
        data["externalRef"] = this.externalRef;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["nationality"] = this.nationality;
        data["phone"] = this.phone;
        if (Array.isArray(this.schoolIds)) {
            data["schoolIds"] = [];
            for (var _d = 0, _e = this.schoolIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["schoolIds"].push(item);
            }
        }
        data["theme"] = this.theme;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined;
        if (Array.isArray(this.expectations)) {
            data["expectations"] = [];
            for (var _f = 0, _g = this.expectations; _f < _g.length; _f++) {
                var item = _g[_f];
                data["expectations"].push(item.toJSON());
            }
        }
        return data;
    };
    return TalentScanDto;
}());
export { TalentScanDto };
var TemplateRequestDto = /** @class */ (function () {
    function TemplateRequestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TemplateRequestDto.prototype.init = function (_data) {
        if (_data) {
            this.filePath = _data["filePath"];
            if (_data["placeholders"]) {
                this.placeholders = {};
                for (var key in _data["placeholders"]) {
                    if (_data["placeholders"].hasOwnProperty(key))
                        this.placeholders[key] = _data["placeholders"][key];
                }
            }
        }
    };
    TemplateRequestDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TemplateRequestDto();
        result.init(data);
        return result;
    };
    TemplateRequestDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        if (this.placeholders) {
            data["placeholders"] = {};
            for (var key in this.placeholders) {
                if (this.placeholders.hasOwnProperty(key))
                    data["placeholders"][key] = this.placeholders[key];
            }
        }
        return data;
    };
    return TemplateRequestDto;
}());
export { TemplateRequestDto };
var UserDto = /** @class */ (function () {
    function UserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserDto.prototype.init = function (_data) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.ssoId = _data["ssoId"];
            this.displayName = _data["displayName"];
        }
    };
    UserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserDto();
        result.init(data);
        return result;
    };
    UserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["ssoId"] = this.ssoId;
        data["displayName"] = this.displayName;
        return data;
    };
    return UserDto;
}());
export { UserDto };
var ValidationError = /** @class */ (function () {
    function ValidationError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidationError.prototype.init = function (_data) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (var _i = 0, _a = _data["validationErrors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationErrors.push(ValidationError.fromJS(item));
                }
            }
        }
    };
    ValidationError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidationError();
        result.init(data);
        return result;
    };
    ValidationError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (var _i = 0, _a = this.validationErrors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationErrors"].push(item.toJSON());
            }
        }
        return data;
    };
    return ValidationError;
}());
export { ValidationError };
var SwaggerException = /** @class */ (function (_super) {
    tslib_1.__extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
